const PLAYBACK_AREA_DEFAULT_ZOOM = 13;

const PLAYBACK_OBJECT_TYPE = {
  MY_VESSELS: 1,
  OTHER_VESSELS: 2,
};

const LAYER_ID = {
  RG_DISPLAY_AREA_LAYER: "rg-display-area-layer",
  RG_HISTORY_TRACK_LAYER: "rg-history-track-layer",
  RG_HISTORY_TRACK_HOVER_EVENT_LAYER: "rg-history-track-hover-event-layer",
  RG_VESSEL_SYMBOL_LAYER: "rg-vessel-symbol-layer",
  RG_VESSEL_POLYGON_LAYER: "rg-vessel-polygon-layer",
  RG_VESSEL_NO_POLYGON_LAYER: "rg-vessel-no-polygon-layer",
  RG_VESSEL_TEXT_LAYER: "rg-vessel-text-layer",
  RG_VESSEL_MARKER_LAYER: "rg-vessel-marker-layer",
  RG_VESSEL_DESCRIPTION_LAYER: "rg-vessel-description-layer",
  RG_VESSEL_VECTOR_LAYER: "rg-vessel-vector-layer",
};

const SOURCE_ID = {
  RG_OBJECT_DISPLAY_AREA: "rg-object-display-area",
  RG_OBJECT_TRACKS: "rg-object-tracks",
  RG_OBJECT_POINTS: "rg-object-points",
  RG_OBJECT_VECTORS: "rg-object-vectors",
};

const PLAYBACK_STATUS = {
  PLAY: 1,
  PAUSE: 2,
  REPLAY: 3,
};

const RG_WAKE_LINE_POPUP_WRAPPER_CLASS_NAME = "rg-wake-line-popup-wrapper";

const PLAYBACK_ERROR_MESSAGES = {
  DATA_NOT_EXISTS: "航海記録データがありませんでした", // ステータス：200で、かつ航海記録のデータない時
  DATA_FETCH_FAILED: "航海記録データ取得に失敗しました", // ステータス：500、401、403
};

const PLAYBACK_DATE_OFFSET = 2; //

export default {
  PLAYBACK_AREA_DEFAULT_ZOOM,
  PLAYBACK_OBJECT_TYPE,
  LAYER_ID,
  SOURCE_ID,
  PLAYBACK_STATUS,
  RG_WAKE_LINE_POPUP_WRAPPER_CLASS_NAME,
  PLAYBACK_ERROR_MESSAGES,
  PLAYBACK_DATE_OFFSET,
};
